<wr-new-data-table
  [insideCard]="false"
  localStorageIdentifier="building-tga-overview"
  [loadItemsFunction]="loadTgas"
  [getCountFunction]="getTgaCount"
  (lineClick)="navigateToTga($event)"
  [form]="tgaListFilterForm"
  [isAdmin]="false">
  <ng-template dataTableFilter>
    <form *ngIf="tgaListFilterForm" [formGroup]="tgaListFilterForm" class="filter-form">
      <div class="filter-control-group">
        <label class="label" for="textFilter">Textfilter</label>
        <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
      </div>
      <div class="filter-control-group">
        <label class="label" for="equipmentSelect">TGA Baupläne</label>
        <wr-tga-type-select [tenantId]="undefined" id="equipmentSelect" formControlName="equipment"></wr-tga-type-select>
      </div>
      <div class="filter-control-group">
        <label class="label" for="creatorTenantSelect">Firmen</label>
        <wr-tenant-select id="creatorTenantSelect"
                          formControlName="creatorTenantId"
                          [tenantType]="TenantTypeEnum.Internal"
                          [showEmptyOption]="true">
        </wr-tenant-select>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="equipmentName"
    exportKey="equipment.name"
    display="TGA Bauplan">
    <wr-tga-type-badge [tgaType]="buildingEquipment.equipment"></wr-tga-type-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="quantity"
    display="Anzahl">
    <div *ngIf="buildingEquipment.quantity">
      {{buildingEquipment.quantity}}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="building"
    exportKey="buildingSection.sectionText"
    display="Gebäudeteil">
    <wr-building-section-badge [buildingSection]="buildingEquipment.buildingSection"></wr-building-section-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingEquipment
    key="creatorTenant"
    exportKey="creatorTenant.name"
    display="Firma">
    <wr-tenant-badge [tenant]="buildingEquipment.creatorTenant"></wr-tenant-badge>
  </ng-template>
</wr-new-data-table>
